// addresses modules
import axios from 'axios';
import moment from 'moment';
import { ADDRESS_URL, DEFAULT_ADDRESS_URL, MULTILEVEL_MARKETING_URL, MULTILEVEL_MARKETING_WITHDRAW_URL, INVITE_HISTORY_URL } from '../../api/url.js';
import { STATES } from '../../../config/default';

// initial state
const state = {
  customerDetails: [],
  defaultAddress: {},
  networkData: [],
  states: STATES,
  withdrawHistoryData: [],
  inviteHistoryData: [],
  // successfullyPosted: false,
  friendCount: 0,
}

// actions
const actions = {
  // Invite history
  async fetchInviteHistory(context) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'get',
      url: INVITE_HISTORY_URL,
      // params: {
      // },
      headers: {
        Authorization: `JWT ${token}`,
      },
    };
    await axios(config)
      .then((response) => {
        context.commit('fetchInviteHistory', response.data);
      }, (err) => {
        console.log("fetchInviteHistory error:", err);
      })
  },

  // MLM network
  async fetchMLMNetwork(context, mobile_user_id) {
    const token = localStorage.getItem('token');
    let output = -1;
    if (mobile_user_id) {
      output = mobile_user_id;
    }
    const config = {
      method: 'get',
      url: MULTILEVEL_MARKETING_URL,
      params: {
        mobile_user_id: output,
      },
      headers: {
         Authorization: `JWT ${token}`,
      },
    };
    await axios(config) 
    .then((response) => {
      context.commit('fetchMLMNetwork', response.data);
    }, (err) => {
      console.log("fetchMLMNetwork error:", err);
    })
  },

  // fetchAddresses
  async fetchAddresses(context) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'get',
      url: ADDRESS_URL,
      headers: {
         Authorization: `JWT ${token}`,
      },
    };
  await axios(config) 
    .then((response) => {
      context.commit('fetchAddresses', response.data);
    }, (err) => {
      console.log("fetchAddresses error:", err);
    })
  },
  // fetchAddresses
  async fetchDefaultAddress(context) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'get',
      url: DEFAULT_ADDRESS_URL,
      headers: {
         Authorization: `JWT ${token}`,
      },
    };
  await axios(config) 
    .then((response) => {
      context.commit('fetchDefaultAddress', response.data);
    }, (err) => {
      console.log("fetchDefaultAddress error:", err);
    })
  },
  // postAddress
  async postAddress({ commit, dispatch }, address) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'post',
      url: ADDRESS_URL,
      data: address,
      headers: {
         Authorization: `JWT ${token}`,
      },
    };
    return axios(config) 
    // .then((response) => {
    //   dispatch('fetchAddresses');
    // }, (err) => {
    //   alert('error happen when create address, please contact us.');
    // })
  },
  // editAddress
  editAddress(context,[address, customerDetail_id]) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'put',
      url: `${ADDRESS_URL}/${customerDetail_id}`,
      data: address,
      headers: {
         Authorization: `JWT ${token}`,
      },
    };
    return axios(config) 
    // .then((response) => {
    //   location.reload();
    // }, (err) => {
    //   alert('error happen when edit address, please contact us.');
    // })
  },
  // deleteAddress
  deleteAddress({ dispatch }, customerDetail_id) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'delete',
      url: `${ADDRESS_URL}/${customerDetail_id}`,
      headers: {
         Authorization: `JWT ${token}`,
      },
    };
    axios(config) 
    .then((response) => {
      dispatch('fetchAddresses')
      // location.reload();
    }, (err) => {
      alert('error happen when delete address, please contact us.');
    })
  },

  // WITHDRAWS
  async fetchWithdraw(context, mobile_user_id) {
    const token = localStorage.getItem('token');
    // let output = -1;
    // if (mobile_user_id) {
    //   output = mobile_user_id;
    // }
    const config = {
      method: 'get',
      url: MULTILEVEL_MARKETING_WITHDRAW_URL,
      params: {
        // mobile_user_id: output,
        type: "out",
        remark: "withdraw",
        page: 1,
        limit: 99999,
      },
      headers: {
        Authorization: `JWT ${token}`,
      },
    };
    await axios(config)
      .then((response) => {
        context.commit('fetchWithdraw', response.data.record);
      }, (err) => {
        console.log("fetchWithdraw error:", err);
      })
  },

  postWithdraw(context, data) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'post',
      url: MULTILEVEL_MARKETING_WITHDRAW_URL,
      data: data,
      headers: {
         Authorization: `JWT ${token}`,
      },
    };
    return axios(config) 
  },
};

// mutations
const mutations = {
  fetchAddresses(state, payload) {
    state.customerDetails = payload.Customer_Detail;
  },
  fetchDefaultAddress(state, payload) {
    state.defaultAddress = payload;
  },
  fetchMLMNetwork(state, payload) {
    state.networkData = payload;
  },
  fetchWithdraw(state, payload) {
    if (payload) {
      payload.map((r, i) => {
        payload[i].CreateTime = moment(r.CreateTime).format('MM-DD-YY HH:mm');
        payload[i].WithdrawDollar = payload[i].WithdrawDollar.toFixed(2);
        if (payload[i].WithdrawStatus === 0) {payload[i].WithdrawStatus = 'Canceled'}
        if (payload[i].WithdrawStatus === 1) {payload[i].WithdrawStatus = 'Paying'}
        if (payload[i].WithdrawStatus === 2) {payload[i].WithdrawStatus = 'Pending'}
        if (payload[i].WithdrawStatus === 3) {payload[i].WithdrawStatus = 'Paid'}
      })
    }
    state.withdrawHistoryData = payload;
  },
  fetchInviteHistory(state, payload) {
    state.inviteHistoryData = payload;
  },
  setFriendCount(state, payload) {
    state.friendCount = payload;
  },
}

export default {
  strict: true,
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/addresses.js